import { defineStore } from "pinia";
import axios from 'axios';
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
export const useGajiSkemaTetapStore = defineStore('gajiSkemaTetapStore', {
    state: () => ({
        data: null
    }),
    getters: {
        filter(){
            return this.data.filter(g => g.nama);
        }
    },
    actions: {
        async get() {
          // Fetch data only if it hasn't been fetched before
          
          if (!this.data) {
            try {
              const config = {
                headers: {
                  Authorization: api.defaults.headers.common["Authorization"],
                  "content-type": "application/json",
                },
              };
              var pegawaiStatus = 2; //direksi
              // var jabatanId = 2;//dirum
             
              var res = await axios.get(`${API_BASE_URL}/gajiSkema/${pegawaiStatus}`, config);
              this.data = res.data;
            } catch (error) {
              console.error('gajiSkemaTetapStore Error fetching:', error);
            }
          }

          return this.data;
         
        },
        // reset(){
        //     console.log("gajiSkemaTetapStore clear")
        //     this.data = null;
        //     // this.get();
            
        // }
        async reset() {  // Add async
          this.data = null;  // Clear the store
          
          const newData = await this.get();  // Fetch new data
          
          this.data = newData;  // Store the fetched data
          return this.data;  // Ensure reset() returns the data
      }
        
    },
     onInit() {
        this.get();
    },
    persist: true,
    onBeforeMount() {
      this.get();
  },

});